var map = {
	"./blackgold.png": "./src/assets/images/theme-img/blackgold.png",
	"./fox.png": "./src/assets/images/theme-img/fox.png",
	"./harvestjoy.png": "./src/assets/images/theme-img/harvestjoy.png",
	"./maidenheart.png": "./src/assets/images/theme-img/maidenheart.png",
	"./minions.png": "./src/assets/images/theme-img/minions.png",
	"./naughtybear.png": "./src/assets/images/theme-img/naughtybear.png",
	"./peachblossom.png": "./src/assets/images/theme-img/peachblossom.png",
	"./soot.png": "./src/assets/images/theme-img/soot.png",
	"./thebigblue.png": "./src/assets/images/theme-img/thebigblue.png",
	"./universe.png": "./src/assets/images/theme-img/universe.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/theme-img sync recursive ^\\.\\/.*\\.png$";